import React, { useContext } from 'react';
import BarChart from 'components/@common/Charts/BarChart';
import { PrintViewContext } from '../../../../providers/PrintViewProvider';

interface OverallCurriculumProgressChartProps {
  series: number[];
  labels: string[];
  onClick?: (index: number) => void;
}

const OverallCurriculumProgressChart: React.FC<OverallCurriculumProgressChartProps> = ({
  series,
  labels,
  onClick
}) => {
  const { fullChartWidth } = useContext(PrintViewContext);

  return (
    <BarChart
      height={250}
      width={fullChartWidth}
      onClick={onClick}
      series={[{ data: series }]}
      options={{
        colors: ['#0F6DB8'],
        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 4,
          decimalsInFloat: 0,
          title: {
            offsetX: -2,
            text: 'Overall Curriculum Progress',
            style: {
              color: '#373D3F',
              fontSize: '12px',
              fontWeight: 700,
              fontFamily: 'futura-pt'
            }
          }
        },
        xaxis: {
          categories: labels,
          labels: {
            offsetY: -4,
            style: {
              colors: '#373D3F',
              fontSize: '10px',
              fontFamily: 'futura-pt'
            }
          },
          axisTicks: { show: false }
        },
        legend: { show: false },
        dataLabels: { enabled: false },
        tooltip: {
          y: {
            title: { formatter: (): string => '' }
          }
        }
      }}
    />
  );
};

export default React.memo(OverallCurriculumProgressChart);
